import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'app/core/auth.service';
import { apiUrlEnum } from 'app/enums/api-endpoints.enums';
import { Client } from 'app/interfaces/client.interface';
import { ReqResponse } from 'app/interfaces/general/response.interface';
import { RespondersDetail, UserAuthProfileRequest, UserDetail, UserGroup } from "app/interfaces/user.interface";
import { DataService } from 'app/services/dataService/data.service';
import * as short from 'short-uuid';
import Swal from 'sweetalert2';

@Component({
    selector: 'responder-dialog.component',
    templateUrl: './responder-dialog.component.html',
    styleUrls: [
        './responder-dialog.component.css'
    ]
})
export class ResponderDialogComponent {
    dialogTitle: string;
    responderInfoForm: FormGroup;
    user: UserDetail = { isActive: true };
    userGroup: UserGroup;

    constructor(public dialogRef: MatDialogRef<ResponderDialogComponent>, private matSnackBar: MatSnackBar, private formBuilder: FormBuilder,private dataService: DataService,private authService: AuthService, @Inject(MAT_DIALOG_DATA) public data?: any) {
        this.dialogTitle = data ? 'Update Responder Information' : 'Add Responder Information';
        let MOBILE_PATTERN = '[- +()0-9]+';
        this.responderInfoForm = this.formBuilder.group({
            key: [short.generate()],
            firstName: ['', Validators.required],
            lastName: ['',Validators.required],
            msisdn: ['',[Validators.pattern(MOBILE_PATTERN)]],
            email: ['', [Validators.email]],
        });

        if (this.data.responder) {
            this.user = this.data.responder.userDetail;
            this.responderInfoForm.patchValue({firstName: this.data.responder.userDetail.firstName})
            this.responderInfoForm.patchValue({lastName: this.data.responder.userDetail.lastName})
            this.responderInfoForm.get('msisdn').disable();
            this.responderInfoForm.patchValue({msisdn: this.data.responder.userDetail.msisdn})
            this.responderInfoForm.get('email').disable();
            this.responderInfoForm.patchValue({email: this.data.responder.userDetail.email})
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    async onSubmit(): Promise<void> {
        
        if (this.responderInfoForm.valid) {
            
            //Create or Update the user.                        
            if (!this.responderInfoForm.get('msisdn').value.includes('+')) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Country Code Needed',
                    text: 'Please ensure to add the country code ex (+27)',
                })
                return;
            }

    
            Swal.fire({
                position: 'center',
                title: 'Saving',
                icon: 'info',
                showConfirmButton: false,
                allowOutsideClick: false,
            })

            

            this.user.firstName = this.responderInfoForm.get('firstName').value;
            this.user.lastName = this.responderInfoForm.get('lastName').value;
            this.user.email = this.responderInfoForm.get('email').value;
            this.user.msisdn = this.responderInfoForm.get('msisdn').value;
    
            if (!this.data.responder) {  
                
                this.userGroup = await this.dataService.getFirestoreDataFromFunctions(this.authService.appUser.userDetail.key, 'userGroups', 'clientKey', this.data.clientKey,'==',1,'autoGenerated','desc');               

                try {
                    this.user.groupKey = this.userGroup.key;
        
                    const userAuthProfileReq: UserAuthProfileRequest = {
                        disabled: false,
                        displayName: this.user.firstName + ' ' + this.user.lastName,
                        msisdn: this.user.msisdn,
                    }

                    if (this.user.email != ''){
                        userAuthProfileReq.email = this.user.email
                    }
        
                    if (this.user.groupKey === (this.userGroup.key || '')) {
                        this.user.subscriptionActive = false;
                        this.user.subscriptionActiveManualPayment = false;
                    } else {
                        this.user.subscriptionActive = true;
                        this.user.subscriptionActiveManualPayment = true;
                    }
                
    
                await this.dataService.postToFunctions(apiUrlEnum.userAuth_v1.user_create_auth_profile, userAuthProfileReq)
                    .then(reqResponse => {
                        if (reqResponse.success) {
    
                            this.user.clientKey = this.data.client.key
                            this.user.isActive = true
                            this.user.responseServiceActionActiveAndListening = false;
                            this.user.responseServiceActionsInitiated = [];
                            this.user.responseServiceActionsResponder = [];
                            this.user.key = reqResponse.data.uid;
                            this.user.roles = {
                                admin: false,
                                clientAdmin: false,
                                providerAdmin: false,
                                user: true,
                                manager: false
                            }
    
                            this.dataService.setFireStoreDataFromFunctions(this.authService.appUser.userDetail.key, 'users', this.user)
                                .then(async () => {
                                    //Add the User to the Response Services. 
                                    const armedResponseIndex = (this.data.client as Client).responseServices.findIndex((service) => {
                                        if (service.category == 'armedResponse') {
                                            return true;
                                        }
                                    });
                                    if (armedResponseIndex != -1) {
                                        (this.data.client as Client).responseServices[armedResponseIndex].responders.push(
                                            {
                                                clientKey: (this.data.client as Client).key,
                                                email: this.user.email,
                                                firstName: this.user.firstName,
                                                key: reqResponse.data.uid,
                                                lastName: this.user.lastName,
                                                msisdn:this.user.msisdn,
                                            },
                                        );
                                    } 

                                    // Save Response Service
                                        await this.dataService.setFireStoreData('responseServices', (this.data.client as Client).responseServices[armedResponseIndex])
                                          .catch(exception => {
                                            console.error(exception)
                                            console.error(exception.message)
                                          })
                                    
                                        // Save response service to client
                                        this.dataService.updateFireStoreData('clients', (this.data.client as Client))
                                    
                                        // Update in all Groups
                                        const clientUserGroups: UserGroup[] = await this.dataService.getFirestoreDataFromFunctions(this.authService.appUser.userDetail.key, 'userGroups', 'clientKey', (this.data.client as Client).key);
                                    
                                        for (const clientUserGroup of clientUserGroups) {
                                          const oldResponseServiceIndex = clientUserGroup.responseServices.findIndex(x => x.key === (this.data.client as Client).responseServices[armedResponseIndex].key)
                                    
                                          if (oldResponseServiceIndex > -1) {
                                            clientUserGroup.responseServices[oldResponseServiceIndex] = (this.data.client as Client).responseServices[armedResponseIndex]
                                            await this.dataService.updateFireStoreData('userGroups', clientUserGroup)
                                          }
                                        }
                                    
                                    Swal.close();
                                    Swal.fire({
                                        icon: 'success',
                                        text: 'User Saved successfully',
                                        allowOutsideClick: false,
                                    }).then((value) => {
                                        this.dialogRef.close(this.data.client);
                                    });
                                }).catch(error => {
                                    throw(error);
                                })
                        } else {
                            throw(reqResponse.error);
                        }
                    }).catch(async error => {
                        console.error(error);
                        let message = error.message;
                        if (error.code == "auth/email-already-exists") {
                            message = "The email address used has already been used by another user. Please check your users again to see if this email address already exist. If the problem persist, please log a ticket with our support team.";
                            if (this.authService.appUser.userDetail.roles.superAdmin) {
                                try {
                                    await this.dataService.getFirestoreDataFromFunctions(this.authService.appUser.userDetail.key, 'users','email',this.user.email,'==')
                                    .then(async (users: UserDetail[]) => {
                                        if (users.length != 0) {
                                            await this.dataService.getFirestoreDataFromFunctions(this.authService.appUser.userDetail.key, 'clients','key',users[0].clientKey,'==')
                                            .then((clients: Client[]) => {
                                                if (clients.length != 0) {
                                                    message = `The email address used has already been used by another user (${users[0].firstName} ${users[0].lastName}). User is currently linked to ${clients[0].name}`;
                                                }
                                            })
                                        }
                                    });
                                } catch(error) {
                                    console.log(`error fetching user/clients in collection: ${error}`);
                                }
                            }
                        } else if (error.code == "auth/phone-number-already-exists") {
                            message = "The phone number used has already been used by another user. Please check your users again to see if this phone number already exist. If the problem persist, please log a ticket with our support team.";
                            if (this.authService.appUser.userDetail.roles.superAdmin) {
                                try {
                                    await this.dataService.getFirestoreDataFromFunctions(this.authService.appUser.userDetail.key, 'users','msisdn',this.user.msisdn,'==')
                                    .then(async (users: UserDetail[]) => {
                                        if (users.length != 0) {
                                            await this.dataService.getFirestoreDataFromFunctions(this.authService.appUser.userDetail.key, 'clients','key',users[0].clientKey,'==')
                                            .then((clients: Client[]) => {
                                                if (clients.length != 0) {
                                                    message = `The phone number used has already been used by another user (${users[0].firstName} ${users[0].lastName}). User is currently linked to ${clients[0].name}`;
                                                }
                                            })
                                        }
                                    });
                                } catch(error) {
                                    console.log(`error fetching user/clients in collection: ${error}`);
                                }
                            }
                        }
    
                        Swal.close();
                        Swal.fire({
                            icon: 'warning',
                            title: 'Error',
                            allowOutsideClick: false,
                            text: message,
                            confirmButtonText: 'Ok'
                        });
                    })
                } catch(error) {
                    Swal.close();
                    Swal.fire({
                        icon: 'warning',
                        title: 'Error',
                        allowOutsideClick: false,
                        text: error.message,
                        confirmButtonText: 'Ok'
                    });
                }
            } else {
                ''
                await this.updateUserAuthProfile(this.user).then(async data => {
                    if (data.success) {        
                        await this.dataService.updateFireStoreDataFromFunctions(this.authService.appUser.userDetail.key, 'users', this.user)
                        Swal.fire({
                            icon: 'success',
                            html: 'UserDetail Updated',
                        }).then((value) => {
                            this.dialogRef.close();
                        });
                    } else {
                        Swal.fire({
                            icon: 'warning',
                            title: 'UserDetail not saved',
                            text: data.message,
                        })
                    }
                }).catch(error => {
                    console.error(error.message)
                    Swal.fire({
                        icon: 'error',
                        title: error.message,
                        text: error.error,
    
                    })
                })
            }
        }  else {
            this.responderInfoForm.markAllAsTouched();
            this.openSnackBar('Required fields missing');
        }
    }

    private openSnackBar(message: string, action?: string) {
        this.matSnackBar.open(message, action, {
            duration: 2000,
        });
    }

    async updateUserAuthProfile(responder: UserDetail): Promise<ReqResponse> {
        const userAuthProfileRequest: UserAuthProfileRequest = {
            disabled: false,
            msisdn: responder.msisdn,
            displayName: `${responder.firstName} ${responder.lastName}`,
            uid: responder.key,
        }

        if (this.user.email != ''){
            userAuthProfileRequest.email = this.user.email
        }

        return this.dataService.postToFunctions(apiUrlEnum.userAuth_v1.user_update_auth_profile, userAuthProfileRequest)
    }
}